import styled from 'styled-components';
import { MenuItem } from '@mui/material';

export const StyledMenuItem = styled(MenuItem)({
  display: 'flex',
  gap: '10px'
});
